import axios, { InternalAxiosRequestConfig } from 'axios'
import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { RefreshActions } from '../state/refresh'
import { useNavigate } from 'react-router-dom'

// Rozszerzamy interfejs AxiosRequestConfig o niestandardową właściwość
declare module 'axios' {
  interface AxiosRequestConfig {
    showLoader?: boolean
  }
}

export const AxiosConfigContainer = (): JSX.Element => {
  const dispatch = useDispatch()
  const navigate = useNavigate()

  const showSpinner = (): void => {
    dispatch(RefreshActions.showSpinner())
  }

  const hideSpinner = (): void => {
    dispatch(RefreshActions.hideSpinner())
  }

  useEffect(() => {
    const requestInterceptor = axios.interceptors.request.use(
      function (config: InternalAxiosRequestConfig<any>) {
        if (config.showLoader !== false) {
          showSpinner()
        }
        return config
      },
      async function (error) {
        return await Promise.reject(error)
      }
    )

    const responseInterceptor = axios.interceptors.response.use(
      function (response) {
        hideSpinner()
        return response
      },
      async function (error) {
        hideSpinner()
        if (error.response?.status === 401) {
          navigate('*')
        }
        return await Promise.reject(error)
      }
    )

    return () => {
      axios.interceptors.request.eject(requestInterceptor)
      axios.interceptors.response.eject(responseInterceptor)
    }
  }, [navigate])

  return <></>
}
